import { IconX } from '@tabler/icons';
import React, { useState } from 'react';
import { getPdfPreviewUrl } from '../utils';

interface ImagesType {
  original: string,
  thumbnail: string,
  isPdf?: boolean,
  fileName?: string,
  fileSize?: string,
}

interface ImagesTypeProps {
  images: Array<ImagesType>
  handleClose: () => void
  selectedImage: number
}

const ImageCarousel = ({ images, handleClose, selectedImage }: ImagesTypeProps) => {
  const [activeIndex, setActiveIndex] = useState(selectedImage || 0);
  const activeImage = images[activeIndex];

  const handleNext = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrev = () => {
    setActiveIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  return (
    <div className="relative flex h-full min-h-[100vh] w-full flex-col items-center justify-center">
      <div className="h-[80vh] w-[80%] overflow-hidden">
        <div className="flex h-full w-full items-stretch transition-all duration-500 ease-in-out" style={{ transform: `translateX(-${activeIndex * 100}%)` }}>
          {images.map(({ original, isPdf }: ImagesType, index: number) => (
            <div key={index} className="h-full w-full flex-shrink-0">
              {isPdf ? (
                <iframe
                  src={getPdfPreviewUrl(original)}
                  title={images[index]?.fileName || `Document ${index + 1}`}
                  className="h-full w-full border-0 bg-white"
                />
              ) : (
                <img
                  src={original}
                  alt={`Image ${index}`}
                  className="h-full w-full object-contain object-center"
                  loading='lazy'
                />
              )}
            </div>
          ))}
        </div>
      </div>

      {images.length > 1 && (
        <>
          <button
            className="absolute top-1/2 left-0 transform -translate-y-1/2 h-12 w-12 text-xl text-white bg-gray-900 rounded-full"
            onClick={handlePrev}
          >
            {" < "}
          </button>

          <button
            className="absolute top-1/2 right-0 transform -translate-y-1/2 w-12 h-12 text-xl text-white bg-gray-900 rounded-full"
            onClick={handleNext}
          >
            {" > "}
          </button>
        </>
      )}

      {activeImage?.fileName && (
        <div className="pointer-events-none absolute bottom-6 left-1/2 max-w-[70%] -translate-x-1/2 text-center text-white">
          <div className="truncate text-sm font-medium">{activeImage.fileName}</div>
          {activeImage.fileSize && (
            <div className="mt-0.5 text-xs text-white/75">{activeImage.fileSize}</div>
          )}
        </div>
      )}

      <div className=' absolute top-4 right-4 text-white cursor-pointer' onClick={() => handleClose()}>
        <IconX size={30} stroke={1.5} />
      </div>
    </div>
  );
};

export default ImageCarousel;
